import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { getUserInfo } from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { errorToast, succToast } from "../../Toast/Toast";
import Style from "./IntroductionCode.module.css";
const IntroductionCode = () => {
  const [IntroCode, setIntroCode] = useState();
  useEffect(() => {
    GetUserInfos();
  }, []);

  const GetUserInfos = async () => {
    getUserInfo((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setIntroCode(res.info.referral);
        }
      }else{
        console.error(res)
      }
    })
  };

  const [copySuccess] = useState("");

  function CopyHandler(e) {
    navigator.clipboard.writeText(e);
    succToast("کپی شد!");
  }
  return (
    <div>
      <BurgerMenuTitle title={"کد معرف شما"} />
      <section className={Style.codeHolder}>
        <div className={Style.ShadowDiv}>
          <div className={Style.picHolder}>
            <img src={"Assets/Images/discount/share.svg"} alt="تخفیف" />
          </div>
          <div className={Style.btnsHolder}>
            {document.queryCommandSupported("copy") && (
              <div>
                <button
                  onClick={() =>
                    CopyHandler(`https://barest.ir/?ref=${IntroCode}`)
                  }
                  className={Style.copyBtn}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
                {copySuccess}
              </div>
            )}
            <form className={Style.code}>
              <p className={Style.codeText}>
                {IntroCode === undefined
                  ? "درحال پردازش"
                  : `https://barest.ir/?ref=${IntroCode}`}
              </p>
            </form>
          </div>

          <div className={Style.btnsHolder}>
            {document.queryCommandSupported("copy") && (
              <div>
                <button
                  onClick={() => CopyHandler(IntroCode)}
                  className={Style.copyBtn}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
                {copySuccess}
              </div>
            )}
            <form className={Style.code}>
              <p className={Style.codeText}>
                {IntroCode === undefined ? "درحال پردازش" : IntroCode}
              </p>
            </form>
          </div>
          <h3>
            <sup>*</sup>این کد را به اشتراک بگذارید و درخرید تخفیف بگیرید
          </h3>
        </div>
      </section>
    </div>
  );
};
export default IntroductionCode;
